import React, { createContext, useState, useContext } from 'react';

const ApplicationContext = createContext();

export const ApplicationProvider = ({ children }) => {
    const [isTranscribing, setIsTranscribing] = useState(false);
    const [error, setError] = useState([]);


    const value = {
        isTranscribing,
        setIsTranscribing,
        error,
        setError
    };

    return (
        <ApplicationContext.Provider value={value}>
            {children}
        </ApplicationContext.Provider>
    );
};

export const useApplication = () => {
    const context = useContext(ApplicationContext);
    if (context === undefined) {
        throw new Error('useApplication must be used within an ApplicationProvider');
    }
    return context;
}; 